import {contactApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const update = async (contact) => {
  try {
    const result = await fetch(`${contactApiHostName}/contact`, {
      method: "PUT",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(contact),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
